module.exports = "https://static.wmbcdn.com/uniweb/images/357341f51a9f7fc6ac79dab4c8c95369.svg";